import React from 'react';
import Tooltip from '../Tooltip/Tooltip';
import './TooltipIconButton.css';

/**
 * Icon button with tooltip (desktop). Optional visible label for mobile/narrow layouts.
 */
export default function TooltipIconButton({
  label,
  tooltip,
  tooltipPosition = 'bottom',
  icon,
  showLabel = false,
  className = '',
  hideTooltipOnPress = true,
  type = 'button',
  ...buttonProps
}) {
  const tooltipText = String(tooltip ?? label ?? '').trim();
  const ariaLabel = String(label ?? tooltipText).trim();

  const button = (
    <button
      type={type}
      className={`tooltip-icon-btn noOutline-text${className ? ` ${className}` : ''}`}
      aria-label={ariaLabel || undefined}
      {...buttonProps}
    >
      {icon ? <span className="tooltip-icon-btn__icon">{icon}</span> : null}
      {showLabel && ariaLabel ? (
        <span className="tooltip-icon-btn__label">{ariaLabel}</span>
      ) : null}
    </button>
  );

  if (!tooltipText) return button;

  return (
    <Tooltip
      text={tooltipText}
      position={tooltipPosition}
      hideOnPress={hideTooltipOnPress}
      className="tooltip-icon-btn__tooltip-wrap"
    >
      {button}
    </Tooltip>
  );
}
